module.exports = "pegasus_template/assets/theme5/small/3.jpg";